module.exports = __webpack_public_path__ + "3e1af3ef546b9e6ecef9f3ba197bf7d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Roboto-Regular.ttf
// module id = 920
// module chunks = 0